module.exports = __webpack_public_path__ + "static/keshav-nandan-a2aeae8540c93a9f5e7b1228707b58cd.jpg";